module.exports = __webpack_public_path__ + "static/media/BS.cbc10545.svg";